import { memo, ReactNode } from "react";
import cx from "classnames";

import styles from "./styles.module.css";

type ThemedLogsAnsiContentProps = {
  text: string;
  searchText: string;
  lineIndex: number;
  currentOccurrenceIndex: number | undefined;
  searchOccurrences: { lineIndex: number; occurrenceIndex: number }[];
};

const ThemedLogsHighlightedText = ({
  text,
  searchText,
  lineIndex,
  currentOccurrenceIndex,
  searchOccurrences,
}: ThemedLogsAnsiContentProps) => {
  if (!searchText.trim()) {
    return text;
  }

  const search = searchText.toLowerCase();
  const lowerText = text.toLowerCase();
  const activeOccurrence =
    currentOccurrenceIndex !== undefined ? searchOccurrences[currentOccurrenceIndex] : undefined;
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let replacementIndex = 0;
  let currentIndex = 0;

  while (currentIndex < lowerText.length) {
    const foundIndex = lowerText.indexOf(search, currentIndex);
    if (foundIndex === -1) break;

    parts.push(text.slice(lastIndex, foundIndex));

    const isActive =
      activeOccurrence?.lineIndex === lineIndex &&
      activeOccurrence.occurrenceIndex === replacementIndex;

    parts.push(
      <mark key={replacementIndex} className={cx("highlight", isActive && styles.active)}>
        {text.slice(foundIndex, foundIndex + search.length)}
      </mark>
    );

    replacementIndex++;
    lastIndex = foundIndex + search.length;
    currentIndex = foundIndex + 1;
  }

  parts.push(text.slice(lastIndex));

  return <>{parts}</>;
};

export default memo(ThemedLogsHighlightedText);
